<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let name: string;
  export let extraClasses: string = "";
  export let fieldObj: {
    errors: string[];
    dirty: boolean;
  };
  export let errorMessages = {};

  const defaultErrorMessages = {
    required: value => `${value} is required`,
    email: value => `${value} format is invalid`,
    notRequiredEmail: value => `${value} format is invalid`,
  };
  // extend default messages with custom errors
  errorMessages = {
    ...defaultErrorMessages,
    ...errorMessages,
  };

</script>

<style>
  .pad-icon-top :global(svg) {
    margin-top: 0.25rem;
  }

</style>

{#if fieldObj && fieldObj.dirty}
  {#each fieldObj.errors as error}
    <p
      class="fizz-flex-row-4 fizz-align-content-start fizz-text-urgent fizz-text-medium {extraClasses}"
    >
      <Icon type="Error" height={20} width={16} />
      <span>{errorMessages[error](name)}</span>
    </p>
  {/each}
{/if}
